/**
 * Shared react-query client factory for MV2 nav modules.
 */
import { QueryClient } from "@tanstack/react-query";

const DEFAULT_QUERY_OPTIONS = {
  staleTime: 5_000,
  gcTime: 30 * 60 * 1000,
  retry: (failureCount, error) =>
    error?.response?.status !== 401 && failureCount < 1,
  refetchOnWindowFocus: true,
};

export function makeMv2QueryClient(options = {}) {
  const { defaultOptions: userDefaults, ...rest } = options;
  return new QueryClient({
    ...rest,
    defaultOptions: {
      ...userDefaults,
      queries: {
        ...DEFAULT_QUERY_OPTIONS,
        ...userDefaults?.queries,
      },
    },
  });
}
